import { BrowserRouter, Switch, Route } from "react-router-dom";
import "./App.css";
import AboutMe from "./Components/AboutMe/AboutMe";
import Blogs from "./Components/Blogs/Blogs";
import Footer from "./Components/Footer/Footer";
import Header from "./Components/Header/Header";
import Home from "./Components/Home/Home.js";
import Project01 from "./Components/Home/projects/Project01";
import Project02 from "./Components/Home/projects/Project02";
import Project03 from "./Components/Home/projects/Project03";
import Portfolio from "./Components/Protfolio/Protfolio";
function App() {
  return (
    <div className="">
      <BrowserRouter>
        <Header></Header>
        <Switch>
          <Route exact path="/">
            <Home></Home>
          </Route>
          <Route exact path="/home">
            <Home></Home>
          </Route>
          <Route exact path="/aboutMe">
            <AboutMe></AboutMe>
          </Route>
          <Route exact path="/portfolio">
            <Portfolio></Portfolio>
          </Route>
          <Route exact path="/blogs">
            <Blogs></Blogs>
          </Route>
          <Route exact path="/project01">
            <Project01></Project01>
          </Route>
          <Route exact path="/project02">
            <Project02></Project02>
          </Route>
          <Route exact path="/project03">
            <Project03></Project03>
          </Route>
        </Switch>
        <Footer></Footer>
      </BrowserRouter>
    </div>
  );
}

export default App;
